export const API_FORGOT_PASSWORD="/identity/users/forgot-password"